import TYPES from '../../action-types';
import * as collectionsHelpers from '../../helpers/collections';

/**
 * Collection removed by someboby
 * @param {string} collectionID
 */
const collectionRemoved = (collectionID) => (dispatch, getState) => {
  const state = getState();
  const allCollectionIds = collectionsHelpers.getAllNestedCollectionIds(
    state.collections.collections,
    collectionID,
  );

  dispatch({
    type: TYPES.COLLECTIONS.REMOVE.COMPLETE,
    payload: { collectionID, nestedCollectionIds: allCollectionIds },
  });
};

export default collectionRemoved;
